import { MutableRefObject } from 'react';
import html2canvas from 'html2canvas';
import { TAddChartOptions, TChartData } from 'views/report/utils/add-chart/types.ts';
import { padding } from 'views/report/utils/style-consts.ts';
import { getCenterXPosition } from 'views/report/utils/utils.ts';

export const addChart = async (
  doc: any,
  chartRef: MutableRefObject<null>,
  options?: TAddChartOptions,
): Promise<Promise<TChartData>> => {
  const { isCentered, positionX, positionY, pageWidth, width, height, useCORS } = options || { useCORS: false };

  if (!chartRef.current) {
    throw new Error('The component is not mounted yet.');
  }

  const element = chartRef.current;
  const canvas = await html2canvas(element, { scale: 2, useCORS });
  const resizedCanvas = document.createElement('canvas');
  const ctx = resizedCanvas.getContext('2d');
  resizedCanvas.width = canvas.width * 0.8;
  resizedCanvas.height = canvas.height * 0.8;
  ctx?.drawImage(canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);

  const imgData = resizedCanvas.toDataURL('image/jpeg', 0.8);
  const pdfWidth = pageWidth || doc.internal.pageSize.getWidth();
  const chartWidth = width || pdfWidth - 2 * padding;
  const chartHeight = height || (resizedCanvas.height * chartWidth) / resizedCanvas.width;

  const x = isCentered ? getCenterXPosition(doc) - chartWidth / 2 : positionX || padding;
  const y = positionY || 35;

  doc.addImage(imgData, 'JPEG', x, y, chartWidth, chartHeight);

  return { chartHeight, chartWidth, x, y };
};
